import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import moment from 'moment';

export function useRemainingTime(options) {
    const { startDate = moment(), endDate, autoUpdate, closed, strict = false } = options;

    const duration = ref(getDuration());

    let updater = null;

    function zLeft(v) {
        return v < 10 ? `0${v}` : v;
    }

    function getDuration() {
        const now = moment();
        const end = moment(endDate);
        const duration = moment.duration(end.diff(now));

        return {
            days: duration.days(),
            hours: duration.hours(),
            minutes: duration.minutes(),
            seconds: duration.seconds()
        };
    }

    function updateDuration() {
        duration.value = getDuration();

        if (duration.value.seconds <= 0) {
            stopUpdater();
        }
    }

    function startUpdater() {
        if (autoUpdate) {
            const autoUpdate = options.autoUpdate === true ? 30 : options.autoUpdate;

            updater = setInterval(() => {
                updateDuration();
            }, autoUpdate * 1000);
        }
    }

    function stopUpdater() {
        if (updater) {
            clearInterval(updater);
            updater = null;
        }
    }

    const ended = computed(() => {
        return closed || (!strict && moment(endDate).isBefore());
    });


    watch(() => autoUpdate, (newValue) => {
        stopUpdater();

        if (newValue) {
            startUpdater();
        }
    });

    watch(() => endDate, () => {
        updateDuration();
    });

    onMounted(() => {
        if (duration.value.days === 0 && autoUpdate) {
            startUpdater();
        }
    });

    onBeforeUnmount(() => {
        stopUpdater();
    });

    const days = computed(() => zLeft(duration.value.days));
    const hours = computed(() => zLeft(duration.value.hours));
    const minutes = computed(() => zLeft(duration.value.minutes));
    const seconds = computed(() => zLeft(duration.value.seconds));

    return {
        ended,
        days,
        hours,
        minutes,
        seconds,
    };
}
